"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canEditElement = exports.hasPermissionForElement = void 0;
var common_utils_1 = require("./common-utils");
var ELEMENT_SCOPE_PREFIX = 'elements.';
var toComparableElementValue = function (rawId) {
    var normalized = common_utils_1.normalizeElementId(rawId);
    var separatorIndex = normalized.indexOf(':');
    return separatorIndex >= 0 ? normalized.slice(separatorIndex + 1) : normalized;
};
exports.hasPermissionForElement = function (permissions, elementId) {
    if (!elementId) {
        return false;
    }
    var normalizedElementId = common_utils_1.normalizeElementId(elementId);
    var comparableElementValue = toComparableElementValue(elementId);
    return permissions.some(function (permission) {
        var normalizedPermission = permission.trim().toLowerCase();
        var normalizedScope = normalizedPermission.startsWith(ELEMENT_SCOPE_PREFIX)
            ? normalizedPermission.slice(ELEMENT_SCOPE_PREFIX.length)
            : normalizedPermission;
        var firstDot = normalizedScope.indexOf('.');
        if (firstDot < 0) {
            return false;
        }
        var category = normalizedScope.slice(0, firstDot);
        var scopeValue = normalizedScope.slice(firstDot + 1);
        if (scopeValue === '*') {
            return (normalizedElementId.indexOf(category + ":") === 0 ||
                normalizedElementId === category ||
                normalizedElementId.indexOf(category + ".") === 0);
        }
        var normalizedScopeId = common_utils_1.normalizeElementId(normalizedScope);
        if (normalizedScopeId === normalizedElementId) {
            return true;
        }
        return toComparableElementValue(normalizedScope) === comparableElementValue;
    });
};
exports.canEditElement = function (role, permissions, elementId) {
    if (role === 'admin') {
        return true;
    }
    if (role !== 'owner' && role !== 'group-owner') {
        return false;
    }
    return exports.hasPermissionForElement(permissions, elementId);
};
